var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1619_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.6895 62.501H37.9688V57.8015H83.9901V18.3538H37.9688V13.6543H88.6895V62.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5213 71.5947H28.4785V4.56445H93.5213V9.26391H33.1811V66.8921H93.5213V71.5947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3407 53.4113H46.4668V22.7451H75.3407V27.4446H51.1663V48.7118H75.3407V53.4113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 93.0829C1 88.585 4.38285 85.5518 8.77364 85.5518C11.9612 85.5518 13.8164 87.2778 14.8432 89.111L12.1785 90.4213C11.5675 89.2433 10.2572 88.3047 8.77364 88.3047C6.10893 88.3047 4.18757 90.3363 4.18757 93.086C4.18757 95.8358 6.10893 97.8674 8.77364 97.8674C10.2572 97.8674 11.5675 96.9287 12.1785 95.7507L14.8432 97.039C13.8164 98.8501 11.9612 100.62 8.77364 100.62C4.386 100.62 1 97.565 1 93.0892L1 93.0829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 94.5224V85.7881H23.0107V94.4342C23.0107 96.4658 24.1887 97.8612 26.4376 97.8612C28.6865 97.8612 29.8425 96.4627 29.8425 94.4342V85.7881H33.008V94.5224C33.008 98.1257 30.8693 100.614 26.4376 100.614C22.0059 100.614 19.8672 98.1257 19.8672 94.5224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5316 100.352L44.6716 95.1773H42.4006V100.352H39.3013V85.791H46.1142C49.1475 85.791 51.0279 87.7785 51.0279 90.4842C51.0279 93.0386 49.39 94.4371 47.8183 94.8088L51.1161 100.356H47.5348L47.5316 100.352ZM47.8371 90.4621C47.8371 89.2621 46.8985 88.5187 45.6764 88.5187H42.4006V92.4496H45.6764C46.8985 92.4496 47.8371 91.7063 47.8371 90.4621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1292 100.352L66.2127 97.8861H59.9698L59.0532 100.352H55.5381L61.1478 85.791H65.0346L70.6475 100.352H67.1324H67.1292ZM63.0881 88.8904L60.8171 95.1553H65.3591L63.0881 88.8904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9978 100.352V88.5187H72.7393V85.791H84.3556V88.5187H80.1192V100.352H76.9978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4028 93.0829C88.4028 88.6952 91.6125 85.5518 96.0221 85.5518C100.432 85.5518 103.619 88.6952 103.619 93.0829C103.619 97.4705 100.41 100.614 96.0221 100.614C91.6345 100.614 88.4028 97.4705 88.4028 93.0829ZM100.432 93.0829C100.432 90.3552 98.7057 88.3015 96.0221 88.3015C93.3385 88.3015 91.5904 90.3552 91.5904 93.0829C91.5904 95.8106 93.3165 97.8642 96.0221 97.8642C98.7278 97.8642 100.432 95.7885 100.432 93.0829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.422 100.352L114.562 95.1773H112.291V100.352H109.191V85.791H116.004C119.038 85.791 120.918 87.7785 120.918 90.4842C120.918 93.0386 119.28 94.4371 117.708 94.8088L121.006 100.356H117.425L117.422 100.352ZM117.724 90.4621C117.724 89.2621 116.786 88.5187 115.563 88.5187H112.288V92.4496H115.563C116.786 92.4496 117.724 91.7063 117.724 90.4621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0781 112.709C22.0781 110.923 23.401 109.704 25.0547 109.704C26.1949 109.704 26.9099 110.252 27.3634 110.933L26.6232 111.323C26.3177 110.835 25.7445 110.479 25.0547 110.479C23.8798 110.479 22.9727 111.402 22.9727 112.709C22.9727 114.016 23.8766 114.939 25.0547 114.939C25.7413 114.939 26.3177 114.583 26.6232 114.095L27.3634 114.485C26.9036 115.166 26.198 115.714 25.0547 115.714C23.401 115.714 22.0781 114.495 22.0781 112.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.641 113.37H30.5512V115.61H29.6787V109.802H32.1261C33.2317 109.802 33.9907 110.517 33.9907 111.588C33.9907 112.659 33.2852 113.191 32.545 113.285L34.0348 115.61H33.0238L31.6379 113.37H31.641ZM32.0127 110.567H30.5512V112.605H32.0127C32.6395 112.605 33.0931 112.196 33.0931 111.585C33.0931 110.973 32.6395 110.564 32.0127 110.564V110.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5073 109.801H40.4099V110.566H37.3798V112.264H40.35V113.03H37.3798V114.841H40.4099V115.606H36.5073V109.798V109.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7127 114.407H43.8653L43.396 115.61H42.4385L44.7473 109.802H45.8371L48.1459 115.61H47.1883L46.719 114.407H46.7127ZM44.1173 113.632H46.4607L45.2859 110.558L44.1205 113.632H44.1173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9804 110.567H49.1787V109.802H53.6451V110.567H51.8497V115.61H50.9772V110.567H50.9804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8848 109.802H56.7573V115.61H55.8848V109.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8801 109.802H59.8723L61.7275 114.662L63.5922 109.802H64.5843L62.2756 115.61H61.1857L58.877 109.802H58.8801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7197 109.801H70.6223V110.566H67.5922V112.264H70.5625V113.03H67.5922V114.841H70.6223V115.606H66.7197V109.798V109.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4937 112.709C76.4937 110.923 77.8166 109.704 79.4702 109.704C80.6104 109.704 81.3254 110.252 81.779 110.933L81.0388 111.323C80.7332 110.835 80.16 110.479 79.4702 110.479C78.2953 110.479 77.3882 111.402 77.3882 112.709C77.3882 114.016 78.2922 114.939 79.4702 114.939C80.1568 114.939 80.7332 114.583 81.0388 114.095L81.779 114.485C81.3191 115.166 80.6136 115.714 79.4702 115.714C77.8166 115.714 76.4937 114.495 76.4937 112.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7918 114.407H84.9444L84.4751 115.61H83.5176L85.8264 109.802H86.9162L89.225 115.61H88.2674L87.7981 114.407H87.7918ZM85.1964 113.632H87.5398L86.365 110.558L85.1996 113.632H85.1964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3574 109.801H95.26V110.566H92.2299V112.264H95.2001V113.03H92.2299V115.606H91.3574V109.798V109.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5845 109.801H101.487V110.567H98.457V112.265H101.427V113.03H98.457V114.841H101.487V115.606H97.5845V109.798V109.801ZM99.2727 109.313L100.526 108.06H101.301L99.846 109.313H99.2696H99.2727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1619_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 119,
    fill: "white",
    transform: "translate(0.5 0.819336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurator);
export default __webpack_public_path__ + "static/media/curator.e0231defab75fb02969dc252d3df242c.svg";
export { ForwardRef as ReactComponent };